// UI Bileşenleri ve Ant Design
import { Card, DatePicker, Input, Select, Table } from "antd";

// Çoklu Dil Desteği
import i18n from "i18n";
import { useTranslation } from "react-i18next";

// Network ve API İşlemleri
import network from "network/network";

// React Hook'ları
import React, { useEffect, useState } from "react";

// Tarih ve Locale Yönetimi
import localeEN from 'antd/es/date-picker/locale/en_GB';
import localeTR from 'antd/es/date-picker/locale/tr_TR';
import moment from 'moment';
import 'moment/locale/tr';
import 'moment/locale/en-gb';

// Redux Yönetimi
import { selectBranchList } from 'utils/redux/actions/branchAction';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Özel Bileşenler ve İkonlar
import ReusableButton from "components/Elements/ReusableButton";
import { ExportOutlined } from "@ant-design/icons";

// Excel Export ve Yardımcı Araçlar
import * as XLSX from 'xlsx';
import tools from 'tools';



// DatePicker'dan RangePicker bileşenini al
const { RangePicker } = DatePicker;

/**
 * Müşteri Damga Raporu bileşeni
 * Müşterilerin damga, kart ve hediye ürün bilgilerini gösterir
 * Tarih, şube, grup ve arama filtrelerine sahiptir
 * Excel export özelliği bulunur
 */
const CustomerStamp = (props) => {
    // Çoklu dil desteği
    const { i18n, t } = useTranslation();
    
    // Ana veri state'leri
    const [customersDetail, setCustomerDetail] = useState([]); // Müşteri detayları listesi
    const [groupList, setGroupList] = useState([]); // Grup listesi
    
    // Filtreleme state'leri
    const [SelectedBranch, setSelectedBranch] = useState(0); // Seçili şube (0 = tümü)
    const [selectedGroups, setSelectedGroups] = useState(); // Seçili grup
    const [searchterm, setSearchTerm] = useState(); // Arama terimi
    const [selectedDates, setSelectedDates] = useState(null); // Seçili tarih aralığı
    
    // Dil ve tarih ayarları
    const currentLang = i18n.language;
    const dateLocale = currentLang === "tr" ? localeTR : localeEN; // Tarih seçici için locale
    const dateFormat = currentLang === "tr" ? 'DD.MM.YYYY' : 'MM/DD/YYYY'; // Tarih formatı
    
    // Moment.js locale ayarı
    moment.locale(currentLang === 'tr' ? 'tr' : 'en-gb');

    // Redux'tan gelen şube listesi
    const { branchList } = props;

    /**
     * Bileşen ilk yüklendiğinde çalışır
     * Müşteri detaylarını ve şube listesini getirir
     */
    useEffect(() => {
        selectCustomerWithStampDetail(); // Müşteri damga detaylarını getir
        var params = {}
        props.selectBranchListAction(params); // Şube listesini Redux'a yükle
    }, [])

    /**
     * Müşteri damga detaylarını ve grup listesini API'dan getiren fonksiyon
     */
    const selectCustomerWithStampDetail = async () => {
        // Müşteri damga detaylarını getir
        const result = await network.get("/admin/Client/getCustomerStampDetails", {}, false);
        // Grup listesini getir
        const resultGroupList = await network.get("/admin/Group/selectGroupList", false);

        const { data } = result.data;
        setCustomerDetail(data);
        setGroupList(resultGroupList.data.data);
    }

    /**
     * Müşteri verilerini filtreleme mantığı
     * Tarih, şube, grup ve arama kriterlerine göre filtreleme yapar
     */
    const filteredData = customersDetail.filter(item => {
        // Eğer herhangi bir filtre seçilmişse filtreleme yap
        if (selectedDates || SelectedBranch || searchterm || selectedGroups) {
            const itemDate = moment(item.insertdate);

            // Tarih aralığı kontrolü
            const isDateValid = selectedDates?.length === 2
                ? itemDate >= selectedDates[0]?.startOf('day') && itemDate <= selectedDates[1]?.endOf('day')
                : true;

            // Şube kontrolü (0 = tüm şubeler)
            const isBranchValid = SelectedBranch ? item.branchid === SelectedBranch : true;

            // Metin normalize etme fonksiyonu (Türkçe karakter desteği için)
            const normalizeText = (text) =>
                text.toLocaleLowerCase('tr').normalize('NFKC');

            // Arama terimi kontrolü (tüm alanlarda arama)
            const isSearch = searchterm
                ? Object.values(item).some(value =>
                    normalizeText(String(value)).includes(normalizeText(searchterm))
                )
                : true;

            // Grup kontrolü (müşterinin gruplarında arama)
            const isGroup = selectedGroups 
                ? item.clientgroups.some(group => selectedGroups == group.groupId) 
                : true;

            // Tüm filtrelerin AND mantığıyla birleştirilmesi
            return isDateValid && isBranchValid && isSearch && isGroup;
        } else {
            // Hiçbir filtre seçilmemişse tüm veriyi döndür
            return customersDetail;
        }
    })

    /**
     * Excel export fonksiyonu
     * Filtrelenmiş müşteri verilerini Excel dosyası olarak indirir
     */
    const handleExcelExport = () => {
        // Filtrelenmiş veriyi Excel formatına dönüştür
        const excelData = filteredData.map((record) => ({
            [t("customerName")]: record.customername,
            [t("customerNumber")]: record.customernumber,
            [t("cardCount")]: record.cardcount,
            [t("stampCount")]: record.stampcount,
            [t("giftProductCount")]: record.giftcount,
            [t("email")]: record.email,
            [t("branch")]: record.branchname,
            [t("registrationDate")]: new Date(record.insertdate).toLocaleDateString(),
        }));

        // Yeni bir Excel çalışma sayfası oluştur
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

        // Excel dosyasını indir
        XLSX.writeFile(workbook, "CustomerData.xlsx");
    };

    /**
     * Tablo kolon tanımları
     * Müşteri bilgilerini gösteren kolonları içerir
     */
    const tableColumn = [
        {
            // Müşteri Adı Kolonu
            title: t("customerName"),
            dataIndex: "customername",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "customername"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.customername}</div>,
        },
        {
            // Müşteri Telefon Numarası Kolonu
            title: t("customerNumber"),
            dataIndex: "customernumber",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "customernumber"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.customernumber}</div>,
        },
        {
            // Kart Sayısı Kolonu
            title: t("cardCount"),
            dataIndex: "cardcount",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "cardcount"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.cardcount}</div>,
        },
        {
            // Damga Sayısı Kolonu
            title: t("stampCount"),
            dataIndex: "stampcount",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "stampcount"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.stampcount}</div>,
        },
        {
            // Hediye Ürün Sayısı Kolonu
            title: t("giftProductCount"),
            dataIndex: "giftcount",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "giftcount"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.giftcount}</div>,
        },
        {
            // E-mail Kolonu
            title: "E-mail",
            dataIndex: "email",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "email"),
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.email}</div>,
        },
        {
            // Şube Adı Kolonu
            title: t("branch"),
            dataIndex: "branchname",
            align: "center",
            render: (_, record) => <div style={{ textAlign: "center" }}>{record.branchname}</div>,
        },
        {
            // Kayıt Tarihi Kolonu (dil ayarına göre formatlanmış)
            title: t("registrationDate"),
            dataIndex: "insertdate",
            align: "center",
            sorter: (a, b) => tools.antdTableSorter(a, b, "insertdate"),
            render: (_, record) => (
                <div style={{ textAlign: "center" }}>
                    {moment(record.insertdate).format(currentLang === "tr" ? "DD.MM.YYYY" : "MM/DD/YYYY")}
                </div>
            ),
        },
    ];





    return (
        <>
            {/* Ana kart bileşeni */}
            <Card title={t("customerStampReport")}>
                {/* Filtreler ve Export butonu için üst kısım */}
                <div className="mb-1" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* Filtreleme kontrolleri */}
                    <div className="mb-2" style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        {/* Tarih aralığı seçici */}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("dateRange")}
                            </label>
                            <RangePicker
                                onChange={(dates) => setSelectedDates(dates)}
                                style={{ width: '100%', maxWidth: '300px' }}
                                format={dateFormat}
                                locale={dateLocale}
                                placeholder={[t("startDate"), t("endDate")]}
                            />
                        </div>

                        {/* Şube seçici */}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("branchSelection")}
                            </label>
                            <Select
                                style={{ width: "150px" }}
                                placeholder={t("selectBranch")}
                                options={[
                                    { value: 0, label: t("all") }, // Tüm şubeler seçeneği
                                    ...branchList.map(item => ({
                                        value: item.branchid,
                                        label: item.branchname
                                    }))
                                ]}
                                onChange={(value) => setSelectedBranch(value)}
                            />
                        </div>

                        {/* Grup seçici */}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("groupSelection")}
                            </label>
                            <Select
                                style={{ width: "150px" }}
                                defaultValue={{ value: 0, label: t("allGroups") }}
                                options={[
                                    { value: 0, label: t("allGroups") }, // Tüm gruplar seçeneği
                                    ...groupList.map(item => ({
                                        value: item.groupid,
                                        label: item.groupname
                                    }))
                                ]}
                                onChange={(value) => setSelectedGroups(value)}
                            />
                        </div>

                        {/* Arama kutusu */}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <label style={{ marginLeft: "4px", marginBottom: "4px", fontWeight: "bold" }}>
                                {t("search")}
                            </label>
                            <Input
                                placeholder={t("searchPlaceholder")}
                                value={searchterm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ width: "200px" }}
                            />
                        </div>
                    </div>

                    {/* Excel export butonu */}
                    <div>
                        <ReusableButton 
                            variant={"template"} 
                            text={t("exportToExcel")} 
                            icon={<ExportOutlined />} 
                            onClick={handleExcelExport} 
                        />
                    </div>
                </div>

                {/* Müşteri verileri tablosu */}
                <Table
                    key={customersDetail.length} // Veri değiştiğinde tabloyu yeniden render et
                    columns={tableColumn}
                    dataSource={filteredData} // Filtrelenmiş veri
                    pagination={{
                        total: filteredData.length,
                        showTotal: (total) => `${t("total")}: ${total}` // Toplam kayıt sayısını göster
                    }}
                />
            </Card>
        </>
    )
}


/**
 * Redux state'ini props'a bağlayan fonksiyon
 * @param {Object} state - Redux store state'i
 * @returns {Object} Bileşende kullanılacak state değerleri
 */
function mapStateToProps(state) {
    return {
        branchList: state.branchReducer.branchList // Şube listesi
    }
}

/**
 * Redux dispatch fonksiyonlarını props'a bağlayan fonksiyon
 * @param {Function} dispatch - Redux dispatch fonksiyonu
 * @returns {Object} Dispatch edilen action'lar
 */
function mapDispatchToProps(dispatch) {
    return {
        selectBranchListAction: bindActionCreators(selectBranchList, dispatch)
    }
}

// Redux connect ile bileşeni export et
export default connect(mapStateToProps, mapDispatchToProps)(CustomerStamp);
